import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {NavigationPipe} from "../../pipes/navigation.pipe";
import {OrderHistoryComponent} from "../../UserCabinet/order-history/order-history.component";
import {MatExpansionModule} from "@angular/material/expansion";
import {OrderByPipe} from "../../pipes/order-by.pipe";
import {CountDownComponent} from "../../UserCabinet/order-history/count-down/count-down.component";
import {MatMenu, MatMenuModule, MatMenuTrigger} from "@angular/material/menu";
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";
import {AccountProfileComponent} from "../../UserCabinet/account-profile/account-profile.component";
import {MatTooltip, MatTooltipModule} from "@angular/material/tooltip";
import {MatFormField, MatLabel, MatOption, MatSelect, MatSelectModule} from "@angular/material/select";
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerModule,
  MatDatepickerToggle
} from "@angular/material/datepicker";
import {MatIcon, MatIconModule} from "@angular/material/icon";
import {ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";


@NgModule({
  declarations: [
    OrderByPipe,
    NavigationPipe,
    OrderHistoryComponent,
    AccountProfileComponent,
    CountDownComponent
  ],
  imports: [
    CommonModule,
    MatTooltipModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    MatMenuModule,
    MatDatepickerModule,
    MatInputModule,
    ReactiveFormsModule
  ],
  exports: [
    OrderByPipe,
    NavigationPipe,
    OrderHistoryComponent,
    AccountProfileComponent,
    CountDownComponent,
    MatExpansionModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
    MatMenuModule,
    MatDatepickerModule,
    MatInputModule,
    ReactiveFormsModule
  ]
})
export class SharedModule { }
